export default function Anime({ children }) {
  return <div className="auth auth--anime twy-bg-base">
    {children}
  </div>
}
